
import {BsCheckCircle} from "react-icons/bs";
import Tippy from "@tippyjs/react";
import { ReactComponent as CrossIcon } from "../../../assets/utils/images/svgs/Cross.svg";
import { ReactComponent as DotCircle } from "../../../assets/utils/images/svgs/Openstaand.svg";

export const iconSwitch = (param) => {
    switch(param) {
        case 'Openstaand':
            return <Tippy content={param} placement="bottom"><span className=""><DotCircle fontSize={"24px"} className="othersSVGs" /></span></Tippy>;
        case 'Goedgekeurd':
            return <Tippy content={param} placement="bottom"><span><BsCheckCircle color='#39A825' fontSize={"20px"}/></span></Tippy>;
        case 'Afgekeurd':
            return <Tippy content={param} placement="bottom"><span className="" ><CrossIcon color='#FB2E5F' fontSize={"26px"}/></span></Tippy>;
        default:
          return '--';
    }
}

export const resultIcon = (param) => {
    switch(param) {
        case 'Openstaand':
            return <Tippy content={param} placement="bottom"><span className=""><DotCircle fontSize={"24px"} color="#ffa73f"/></span></Tippy>;
        case 'Goedgekeurd':
            return <Tippy content={param} placement="bottom"><span><BsCheckCircle color='#39A825' fontSize={"20px"}/></span></Tippy>;
        case 'Afgekeurd':
            return <Tippy content={param} placement="bottom"><span className="" ><CrossIcon color='#FB2E5F' fontSize={"26px"}/></span></Tippy>;
        default:
          return '--';
    }
}
// let str = "q|w|e";
// cosnt key = [1, 2, 3];
// let result = {q: 1, w: 2, e: 3}
export const parse = (sign, str, keys) => {
    const values = str.split(sign);
    let result = {};

    keys.forEach((value, index) => result[value] = values[index]);

    return result;
}
